<template>
    <div name="radio-button" class="radio">
        <img class="icn" v-if="selected" src="../../assets/radio_selected.png" />
        <img @click="select" class="icn" v-else-if="isError" src="../../assets/radio_error.png" />
        <img @click="select" class="icn" v-else src="../../assets/radio_unselected.png" />
        <span class="label">{{ label }}</span>
    </div>
</template>

<script>
export default {
    name: 'radioButton',
    props: ['label', 'selected', 'isError'],
    methods: {
        select: function()
        {
            this.$emit('select')
        }
    }
}
</script>

<style scoped>
    .radio {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        margin-bottom: 17px;
    }
    .icn {
        width: 22px;
        cursor: pointer;
    }
    .label {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 8px;
    }
</style>


// WEBPACK FOOTER //
// src/components/atoms/RadioButton.vue